export function buildPayment(paymentForm: PaymentForm): undefined | PaymentStructure {
    const {
        cardInformation: {
            id: cardId,
            customer: customerId,
            brand,
            lastFourDigits,
            expirationMonth,
            expirationYear
        } = {},
        paypalId,
        paypalEmail
    } = paymentForm;

    if (paypalId && paypalEmail) {
        return {
            paypal: {
                email: paypalEmail,
                baid: paypalId
            }
        };
    }

    if (cardId && customerId && lastFourDigits && expirationMonth && expirationYear) {
        const expMonth = (expirationMonth.toString().length === 1) ? "0".concat(expirationMonth) : expirationMonth;
        const expYear = (expirationYear.toString().length === 2) ? "20".concat(expirationYear) : expirationYear;

        return {
            creditCard: {
                tokenId: cardId,
                secondTokenId: customerId,
                brand,
                lastFourDigits,
                expirationDate: `${ expMonth }${ expYear }`
            }
        };
    }

    return;
}
